// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__1sd59","footerText":"footer_footerText__kZJ8b","socialIcons":"footer_socialIcons__lxzPc","socialIcon":"footer_socialIcon__q+AVT"};